export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/mini-arrow-black.7e3f81a4.svg","height":16,"width":18};